import { render, staticRenderFns } from "./aliyun-captcha.vue?vue&type=template&id=76c453a1&"
import script from "./aliyun-captcha.vue?vue&type=script&lang=js&"
export * from "./aliyun-captcha.vue?vue&type=script&lang=js&"
import style0 from "./aliyun-captcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports